/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import { Injectable } from '@angular/core';
import { TranslationService } from '../translation.service';

/**
 * This service is to hold any methods we wish to reuse elsewhere in the app. Methods that
 * might be useful to have for other future use cases outside component definitions.
 */
@Injectable({
  providedIn: 'root',
})
export class BulbUtilitiesService {
  constructor(private translate: TranslationService) {}

  version: string = '';

  /**
   * Function used to convert an ISO timestamp to the format 'Mmm dd, yyyy'
   * @param dateParam ISO Date timestamp
   * @returns Converted date string with shorthand format 'Mmm dd, yyyy' with month translated
   */
  convertDateWithTranslatedMonth(dateParam: string) {
    // Slice removes the 'Z' at the end of the ISO timestamp to remove UTC.
    const date = new Date(dateParam.slice(0, -1));
    const dateMonth = date.toLocaleDateString('en-us', { month: 'long' });
    return `${this.translate
      .translateInstant(`aero_calendar_short_month_name_${dateMonth
        .toLowerCase()}`)} ${date.getDate()}, ${date.getFullYear()}`;
  }

  /**
   * Response interceptor for checking version header.
   * Params are coming from restangular, must return data down the chain.
   */
  watchVersionsOnRequests(data, operations, what, url, response) {
    this.version = response.headers('X-BULB-VERSION');
    return data;
  }
}
